import {
  AfterViewInit,
  Component,
  OnInit,
} from '@angular/core';
import { SignupService } from '../../../services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { allCountriesList } from 'src/app/shared/countryList';
import { take } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { B2BApiSchedulePickupDialog } from 'src/app/features/B2B/b2b-api-schedule-pickup-dialog/b2b-api-schedule-pickup-dialog';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'app-b2b-pickups',
  templateUrl: './b2b-pickups.component.html',
  styleUrls: ['./b2b-pickups.component.css'],
})
export class B2BPickupsComponent implements OnInit, AfterViewInit {
  xApiToken: string;
  token: string;
  userID: string;
  lang: string;
  memberDetails: any;
  countriesList: any[] = allCountriesList;

  query: string = '';
  loading: boolean = false;
  searchResults: pickupsResponseModel = {
    total: 0,
    page: 0,
    page_size: 0,
    total_pages: 0,
    has_next: false,
    has_previous: false,
    pickups: [],
  };

  pageSizeOptions: number[] = [10, 20, 50, 100];
  pageIndex: number = 0;
  pageSize: number = 10;
  resultsLength: number = 0;
  columns = [
    {
      columnDef: 'carrier',
      header: 'Carrier',
      cell: (element: pickupsModel) => `${element.company_name ?? '-'}`,
    },
    {
      columnDef: 'shipment_number',
      header: 'Shipment Number',
      cell: (element: pickupsModel) => `${element.shipment_number ?? '-'}`,
    },
    {
      columnDef: 'time',
      header: 'Time',
      cell: (element: pickupsModel) =>
        `${element?.start_time ?? '-'} - ${element?.end_time ?? '-'}`,
    },
    {
      columnDef: 'pickup_location',
      header: 'Pickup Location',
      cell: (element: pickupsModel) =>
        `${element?.address_text ?? '-'}`,
    },
  ];

  displayedColumns = this.columns.map((c) => c.columnDef);


  environment: string = 'environment';
  private currentEnvironment: string = 'environment';
  search() {
    if (this.environment === 'production' || this.environment === 'environment') {
      this.loading = true;
      this.signUpService
        .getB2BArrangedPickupsList(
          this.token,
          this.query,
          this.pageIndex + 1,
          this.pageSize
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.searchResults = response;
            this.resultsLength = response.total || 0;
          },
          complete: () => {
            this.loading = false;
          },
        });
    } else {
      this.loading = true;
      this.signUpService
        .getB2BTestArrangedPickupsList(
          this.token,
          this.query,
          this.pageIndex + 1,
          this.pageSize
        )
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            this.searchResults = response;
            this.resultsLength = response.total || 0;
          },
          complete: () => {
            this.loading = false;
          },
        });
    }



  }

  handlePageEvent(event?: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.search();
  }

  handleEnvironmentChange(): void {

    if (this.currentEnvironment !== this.environment) {
      this.pageSize = 10;
      this.pageIndex = 0;
      this.currentEnvironment = this.environment;
    }
    this.search();
  }



  ngOnInit(): void {
    this.search();
    this.displayedColumns = this.columns.map((c) => c.columnDef);
    window.scrollTo(0, 0);
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
  }

  payload = {
    page: 1,
    page_size: 10,
  };

  ngAfterViewInit(): void { }

  openSchedulePickupDialog(): void {
    const senderAddresses = this.memberDetails.addresses;
    const dialogRef = this.dialog.open(B2BApiSchedulePickupDialog, {
      data: senderAddresses,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        window.location.reload();
      }
    })
  }
  copyToClipboard(text: string, thing = ''): void {
    this.clipboard.copy(text);
    this.toastr.success(`${thing} copied to clipboard`, 'Success');
  }
  constructor(
    private signUpService: SignupService,
    private watcherService: WatcherService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private clipboard: Clipboard
  ) {
    this.signUpService.getAllCountries().subscribe({
      next: (list) => {
        this.countriesList = list['data'];
      },
      error: (err) => {
        this.toastr.error(err.error.message, 'Error');
      },
    });
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userID = state.user?.id;
    });
    this.signUpService
      .getUserByUserID(this.userID, this.token)
      .subscribe((data) => {
        this.memberDetails = data['data'];
      });

      this.signUpService.getB2BUserTestAPIKeys(this.token).subscribe({
        next: (data) => { 

          this.xApiToken = data['api_key'];
        },
        error: (error) => { 
          this.toastr.error('Contact with Shippn Support for Creating a Test Account!', 'Error');
        },
      })
  } 
}

export interface pickupsResponseModel {
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
  pickups: pickupsModel[];
}
export interface pickupsModel {
  address_id: string;
  end_time: string;
  start_time: string;
  shipment_number: string;
  shipment_id: string;
  carrier: string;
  address: {
    country_code: string;
    line1: string;
    line2: string;
    line3: string;
    post_code: string;
    state: string;
    city_name: string;
    country_name: string;
  };
  company_name: string;
  address_text:string;
}
